import { render, staticRenderFns } from "./PaymentBilletNeopag.vue?vue&type=template&id=f5fb5bd8&scoped=true&"
import script from "./PaymentBilletNeopag.vue?vue&type=script&lang=js&"
export * from "./PaymentBilletNeopag.vue?vue&type=script&lang=js&"
import style0 from "./PaymentBilletNeopag.vue?vue&type=style&index=0&id=f5fb5bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fb5bd8",
  null
  
)

export default component.exports